export function rand(a: number, b: number) {
  return a + Math.random() * (b - a);
}
